import * as Msal from 'msal'

const msalConfig = {
  auth: {
    clientId: 'ba6820f8-537f-4484-816c-846175365bbb',
    authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
    postLogoutRedirectUri: window.location.origin,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true
  }
}

const loginRequest = {
  scopes: ['openid', 'profile', 'email']
}

const apiTokenRequest = {
  scopes: ['https://cmms-test.azure.chevron.com/user_impersonation']
}

let instance = null
let redirectCallbackRegistered = false

function parseHashToken() {
  if (!window.location.hash) {
    return ''
  }

  const hash = window.location.hash.replace(/^#/, '')
  const params = new URLSearchParams(hash)

  return params.get('access_token') || ''
}

function clearHash() {
  if (window.location.hash) {
    window.history.replaceState({}, document.title, window.location.pathname)
  }
}

export default {
  msalInstance: null,

  getInstance() {
    if (!instance) {
      instance = new Msal.UserAgentApplication(msalConfig)
      this.msalInstance = instance
    }

    if (!redirectCallbackRegistered) {
      redirectCallbackRegistered = true

      instance.handleRedirectCallback((error, response) => {
        sessionStorage.removeItem('api_token_redirect_started')

        const hashAccessToken = parseHashToken()

        if (hashAccessToken) {
          sessionStorage.setItem('last_api_access_token', hashAccessToken)
        }

        clearHash()
      })
    }

    return instance
  },

  initialize() {
    const msalInstance = this.getInstance()

    return new Promise((resolve) => {
      const hashAccessToken = parseHashToken()

      if (hashAccessToken) {
        sessionStorage.setItem('last_api_access_token', hashAccessToken)
        sessionStorage.removeItem('api_token_redirect_started')
        clearHash()
      }

      resolve(msalInstance.getAccount())
    })
  },

  login() {
    const msalInstance = this.getInstance()

    sessionStorage.removeItem('api_token_redirect_started')
    sessionStorage.setItem('sso_auth_flow_started_at', Date.now().toString())

    msalInstance.loginRedirect(loginRequest)
  },

  async acquireToken() {
    const msalInstance = this.getInstance()
    const account = msalInstance.getAccount()

    if (!account) {
      sessionStorage.removeItem('api_token_redirect_started')
      return null
    }

    const cachedRedirectToken = sessionStorage.getItem('last_api_access_token')

    if (cachedRedirectToken && !this.isTokenExpired(cachedRedirectToken)) {
      sessionStorage.removeItem('api_token_redirect_started')
      return cachedRedirectToken
    }

    try {
      const tokenResponse = await msalInstance.acquireTokenSilent(apiTokenRequest)

      sessionStorage.removeItem('api_token_redirect_started')

      if (tokenResponse && tokenResponse.accessToken) {
        sessionStorage.setItem('last_api_access_token', tokenResponse.accessToken)
        return tokenResponse.accessToken
      }

      return null
    } catch (error) {
      return null
    }
  },

  acquireApiTokenRedirect() {
    const msalInstance = this.getInstance()

    if (!this.isInteractiveSsoFlowActive()) {
      return
    }

    if (sessionStorage.getItem('api_token_redirect_started') !== 'true') {
      sessionStorage.setItem('api_token_redirect_started', 'true')
      msalInstance.acquireTokenRedirect(apiTokenRequest)
    }
  },

  isAuthenticated() {
    const msalInstance = this.getInstance()
    return !!msalInstance.getAccount()
  },

  getUserEmail() {
    const msalInstance = this.getInstance()
    const account = msalInstance.getAccount()

    if (account && account.userName) {
      return account.userName
    }

    return localStorage.getItem('useremail') || ''
  },

  completeSsoFlow() {
    sessionStorage.removeItem('api_token_redirect_started')
    sessionStorage.removeItem('sso_auth_flow_started_at')
  },

  signOut() {
    const msalInstance = this.getInstance()

    sessionStorage.removeItem('api_token_redirect_started')
    sessionStorage.removeItem('last_api_access_token')

    msalInstance.logout()
  },

  isInteractiveSsoFlowActive() {
    const startedAt = Number(sessionStorage.getItem('sso_auth_flow_started_at'))

    if (!startedAt) {
      return false
    }

    // allow only for 5 minutes
    const maxAgeMs = 5 * 60 * 1000

    return Date.now() - startedAt <= maxAgeMs
  },

  isTokenExpired(token) {
    try {
      const payloadPart = token.split('.')[1]

      if (!payloadPart) {
        return true
      }

      const base64 = payloadPart
        .replace(/-/g, '+')
        .replace(/_/g, '/')

      const paddedBase64 = base64.padEnd(
        base64.length + (4 - base64.length % 4) % 4,
        '='
      )

      const payload = JSON.parse(atob(paddedBase64))

      return Date.now() >= payload.exp * 1000
    } catch (error) {
      return true
    }
  }
}
